import axios, { AxiosResponse } from "axios";
import { API_URL } from "../constants";
import { UserInfo } from "../contexts/UserInfoContext";
import { resolveAccessToken } from "./Auth";

export type DiscoveryStatus = 'recommended' | 'complete' | 'skipped' | 'disabled';

export interface DiscoveryStatusResult {
  status: DiscoveryStatus;
  reason: string;
  targetPersonaId: string;
  guidePersonaId: string;
  guideProfileId: string;
  tenantId: string;
  progressPercentage: number;
  activeClaimCount: number;
  requiredCriteria: string[];
  satisfiedCriteria: string[];
  partialCriteria: string[];
  missingCriteria: string[];
  missingRequiredCriteria: string[];
}

export async function getDiscoveryStatus(
  userInfo: UserInfo,
  personaId: string,
  discoveryTestRunId?: string | null,
): Promise<DiscoveryStatusResult | undefined> {
  const token = await resolveAccessToken(userInfo?.accessToken);
  if (!token) {
    return undefined;
  }

  const query = discoveryTestRunId
    ? `?discoveryTestRunId=${encodeURIComponent(discoveryTestRunId)}`
    : '';
  const response: AxiosResponse<DiscoveryStatusResult> = await axios.get(
    `${API_URL}/discovery/status/${encodeURIComponent(personaId)}${query}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
}
